module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAUCAYAAACEYr13AAAAgklEQVQ4EaXBsQ3AMAzAMOn/o12NhqcAJeUn+UmOCQ8MkWPCA0PkmPDAEDkmPDBEjgmLIRMWQ+SYsBgyYTFEjgmLIRMWQ+SYsBgyYTFEjgmLIRMWQ+SYsBgyYTFEjgmLIRMWQ+SYsBgyYTFEjgkPDJFjwgND5JjwwBA5JjwwRH6Snz4/0GAVMBeYwAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/flappybird/number_score_00.png
// module id = 233
// module chunks = 0